export default __webpack_public_path__ + "static/assets/images/join-hex-left.cab2b3379036119af013d9f76dd9db21.svg";